import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { MatSelectChange } from "@angular/material";

import { SamlWizardService } from "../saml-wizard.service";
import { TranslateService } from "../../../../common/translate/translate.service";
import { SnackbarService } from "../../../../common/snackbar/snackbar.service";
import { AbstractWizardStepComponent } from "../../../wizard-dialog/abstract-wizard-step.component";
import { SamlDownloadComponent } from "../saml-download/saml-download.component";

@Component({
	templateUrl: "./saml-select-idp.component.html"
})
export class SamlSelectIdpComponent extends AbstractWizardStepComponent<void> implements OnInit {
	public form: FormGroup;
	public providerData: string[] = [];
	public isDataLoaded = false;
	public isFormInvalid = true;

	constructor(
		private service: SamlWizardService,
		private formBuilder: FormBuilder,
		private translateService: TranslateService,
		private snackbarService: SnackbarService
	) {
		super();

		this.form = this.formBuilder.group({
			idpName: [
				this.service.identityProvider.name || ""
			]
		});
	}

	public async ngOnInit() {
		await this.refresh();
		if (this.service.identityProvider.name && this.service.identityProvider.name.length > 0) {
			this.isFormInvalid = false;
		}
	}

	private async refresh() {
		try {
			this.isDataLoaded = false;
			this.providerData = (await this.service.getIdentityProviderOptions()).sort((a, b) => {
				a = a.toLocaleLowerCase();
				b = b.toLocaleLowerCase();
				if (a === "custom" && b === "custom") {
					return 0;
				} else if (a === "custom") {
					return 1;
				} else if (b === "custom") {
					return -1;
				} else {
					return a.localeCompare(b);
				}
			});
		} catch (e) {
			this.snackbarService.open(this.translateService.translate(e));
		} finally {
			this.isDataLoaded = true;
		}
	}

	public onChange(event: MatSelectChange) {
		if (event.value.length > 0) {
			this.isFormInvalid = false;
		}
	}

	public get title() {
		return "saml.wizard.selectIdp.title";
	}

	public get description() {
		return "saml.wizard.selectIdp.description";
	}

	public get nextStep() {
		return SamlDownloadComponent;
	}

	public get previousStep(): AbstractWizardStepComponent.ConstructorFunction<void> | undefined {
		return undefined;
	}

	public get isFormValid() {
		return !this.isFormInvalid;
	}

	public async performPrevious() {
		if (this.idpName !== undefined) {
			this.service.processSelectIdp(this.idpName);
		}
	}

	public async performNext() {
		if (this.idpName === undefined) {
			this.snackbarService.open(this.translateService.translate("saml.wizard.select.idp.name.undefined"));
		} else {
			this.service.processSelectIdp(this.idpName);
		}
	}

	public get showProgressBar() {
		return !this.isDataLoaded;
	}

	private get idpName(): string | undefined {
		return this.form.getRawValue().idpName;
	}
}
